export default __webpack_public_path__ + "static/Pair-0ae032453ca9d22f2d7c23168457109f.png";